export enum PopupComponentsEnum {
	AccountVerificationInfo,
	AnnualIncomeInfo,
	BettingDisabledInfo,
	DepositLimitInfo,
	DocumentExpirationInfo,
	UseMarketplaceBonus,
	WelcomeInfo,
	CreditRatingInfo,
	WalletGracePeriodInfo,
	None,
}
